import React, { useState } from 'react';
import { ManagerView } from './pages/ManagerView';
import { AdminView } from './pages/AdminView';
import { RvpView } from './pages/RvpView';
import { useScreenInit } from './useScreenInit.js';
import { DataProvider, useData, availableWeeks } from './context/DataContext';
import { LayoutDashboard, Users, Calendar as CalendarIcon, Search, ChevronDown } from 'lucide-react';
import { cn } from './components/ui/Card';
type ViewMode = 'manager' | 'rvp' | 'admin';
function AppContent() {
  const screenInit = useScreenInit();
  const [view, setView] = useState<ViewMode>(screenInit?.view as ViewMode || 'manager');
  const {
    selectedWeek,
    setSelectedWeek
  } = useData();
  return <div className="min-h-screen bg-slate-50/50 font-sans text-slate-900" data-id="element-0">
      {/* Global Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50" data-id="element-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
          <div className="flex justify-between items-center h-16" data-id="element-3">
            {/* Left: Logo & Title */}
            <div className="flex items-center space-x-4" data-id="element-4">
              <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center" data-id="element-5">
                <LayoutDashboard className="w-5 h-5 text-white" data-id="element-6" />
              </div>
              <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-7">
                Accountability
                <span className="text-slate-400 font-light" data-id="element-8">Hub</span>
              </span>
            </div>

            {/* Center: View Toggle */}
            <div className="hidden md:flex bg-slate-100 p-1 rounded-lg" data-id="element-9">
              <button onClick={() => setView('manager')} className={cn('px-4 py-1.5 text-sm font-medium rounded-md transition-all', view === 'manager' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-900')} data-id="element-10">
                Manager View
              </button>
              <button onClick={() => setView('rvp')} className={cn('px-4 py-1.5 text-sm font-medium rounded-md transition-all', view === 'rvp' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-900')} data-id="element-11">
                RVP View
              </button>
              <button onClick={() => setView('admin')} className={cn('px-4 py-1.5 text-sm font-medium rounded-md transition-all', view === 'admin' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-900')} data-id="element-12">
                Executive View
              </button>
            </div>

            {/* Right: Controls & Profile */}
            <div className="flex items-center space-x-4" data-id="element-13">
              <div className="hidden md:flex items-center relative" data-id="element-14">
                <select value={selectedWeek} onChange={e => setSelectedWeek(e.target.value)} className="appearance-none bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 py-1.5 pl-9 pr-8 focus:outline-none focus:ring-2 focus:ring-slate-900 cursor-pointer" data-id="element-15">
                  {availableWeeks.map(week => <option key={week.id} value={week.id} data-id="element-16">
                      {week.label}
                    </option>)}
                </select>
                <CalendarIcon className="w-4 h-4 text-slate-400 absolute left-3 pointer-events-none" data-id="element-17" />
                <ChevronDown className="w-4 h-4 text-slate-400 absolute right-3 pointer-events-none" data-id="element-18" />
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main data-id="element-19">
        {view === 'manager' && <ManagerView data-id="element-20" />}
        {view === 'rvp' && <RvpView data-id="element-21" />}
        {view === 'admin' && <AdminView data-id="element-22" />}
      </main>
    </div>;
}
export function App() {
  return <DataProvider data-id="element-23">
      <AppContent data-id="element-24" />
    </DataProvider>;
}